<mat-card>
  <mat-card-title>Cette page vous permet de gérer vos formulaires</mat-card-title>
  <mat-card-subtitle>Créer ou modifier ou dupliquer des formulaires, gérer les gestionnaires associés, obtenir le lien à partager, accéder aux demandes d'une procédure</mat-card-subtitle>
  <mat-card-content fxLayout="column">
    <div fxLayout="row" fxFlexAlign="end" style="padding-top: 5px" fxLayoutGap="10px">
      <div class="form-group">
        <mat-form-field>
          <mat-label>Filtrer par Catégories</mat-label>
          <mat-select
            [(ngModel)]="itemCategories"
            (selectionChange)="onSelectState($event)"
            multiple
            data-cy="select-form-modal-categories">
            <mat-option *ngFor="let cat of categoriesList" [value]="cat.id" [disabled]="!cat.active">
              {{cat.name}}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="!categoriesList?.length">Aucune catégorie disponible</mat-hint>
        </mat-form-field>
      </div>
      <button [routerLink]="['creation-formulaire']" color="accent" mat-raised-button matTooltip="Créer un nouveau formulaire"
              routerLinkActive="true" data-cy="btn-form-list-new-form">
        <mat-icon data-cy="icon-form-list-add" >add</mat-icon>
        NOUVEAU FORMULAIRE
      </button>
    </div>

    <app-data-table
      [actions]="actions"
      [columns]="columns"
      [dataSource]="dsFormulaires"
      [extraParams]="extraParams"
      [filterDisplay]="true"
      [flexAction]="5"
      [flexColumn]="90"
      [fontSizeCell]="'0.9em'"
      [minFilter]="1" [pageSize]="10"
      [pageSizesList]="[5,10,25]" [placeHolderFilter]="'Rechercher des formulaires'"
      [refreshButton]="true"
      [refreshIcone]="false"
      [showFirstLastButtons]="true"
      [showLoader]="true"
      [loaderMask]="true"
      [loaderProgress]="false"
      [toolTipFilter]="'Recherche de formulaire'">
    </app-data-table>
  </mat-card-content>
</mat-card>
